import { economicsConstants } from '../constants'

const initialState = {
  list: [],
  error: null,
  loading: false,
  ajaxSpinner: false,
  ajaxStatus: null,
  ajaxAction: null
}

export default function economics(state = initialState, action) {
  switch (action.type) {
    case economicsConstants.LOADING_ECONOMICS:
      return { ...state, loading: true, error: null }
    case economicsConstants.LOADING_ECONOMICS_ERROR:
      return { ...state, loading: false, error: action.payload }
    case economicsConstants.UPDATE_ECONOMIC:
      return {
        ...state,
        list:
          state.list === null
            ? [action.payload]
            : state.list.findIndex((x) => x.id === action.payload.id) === -1
            ? state.list.concat(action.payload)
            : state.list.map((item) => {
                return item.id === action.payload.id ? action.payload : item
              }),
        ajaxAction: 'update',
        loading: false
      }
    case economicsConstants.REMOVE_ECONOMIC:
      return {
        ...state,
        list: state.list.filter((item) => {
          return item.id !== action.payload.id
        }),
        ajaxAction: 'remove',
        loading: false
      }
    case economicsConstants.ECONOMICS_AJAX_CALL:
      return { ...state, ajaxSpinner: true, ajaxStatus: null }
    case economicsConstants.ECONOMICS_AJAX_SUCCESS:
      return { ...state, ajaxSpinner: false, ajaxStatus: null }
    case economicsConstants.ECONOMICS_AJAX_FAILURE:
      return { ...state, ajaxSpinner: false, ajaxStatus: action.payload }
    default:
      return state
  }
}
